import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "5c8330b3-9dab-4db9-bdc6-5b432da82fc7",
    options: { image: `${config.ASSETS_URL}/02/12/task/task-3-chart-1.svg` },
  },
  {
    id: "ca186fed-9558-4b28-8aee-086787f523fc",
    options: { image: `${config.ASSETS_URL}/02/12/task/task-3-chart-2.svg` },
  },
  {
    id: "cf0f218c-7030-4052-be02-d72cdc047dad",
    options: { image: `${config.ASSETS_URL}/02/12/task/task-3-chart-3.svg` },
  },
  {
    id: "28e6c6dd-9ee1-45ab-b4e7-b66fa38554e2",
    options: { image: `${config.ASSETS_URL}/02/12/task/task-3-chart-4.svg` },
  },
];

export const task: Task = {
  id: "3a457182-52d5-474f-b285-58bb145c0c0c",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["ca186fed-9558-4b28-8aee-086787f523fc"],
};
